import Card, { SimpleCardWithIcon, ClosabledCard } from './MainCard'
import PropertyDocInfo from './PropertyDocInfo'
import PropertyInterested from './PropertyInterested'
import WellnessCard from './WellnessCard'

export default Card
export {
  SimpleCardWithIcon,
  ClosabledCard,
  PropertyDocInfo,
  PropertyInterested,
  WellnessCard
}
